import React from "react";
import { Link } from "react-router-dom";

function Collage() {
  return (
    <section className="Collage" id="Collage">
      <div className="Collage-home">
        <h1 className="PhotoGallery-title">
          Photo Gallery
        </h1>

        <p className="PhotoGallery-text">
          Explore claw machine fun, prizes, and toy play moments for endless excitement!
        </p>

        <Link to="/photogallery" className="PhotoGallery-link">
          <button className="rounded-button2">
            See more pictures
          </button>
        </Link>
      </div>
    </section>
  );
}

export default Collage;